import { motion } from 'framer-motion';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
}

const springConfig = {
  type: "spring",
  stiffness: 50,
  damping: 20,
  mass: 1
};

export const FeatureCard = ({ title, description, icon: Icon }: FeatureCardProps) => {
  return (
    <motion.div
      whileHover={{ y: -5, scale: 1.02 }}
      transition={{ duration: 0.8, ...springConfig }}
      className="relative p-6 bg-gradient-to-b from-amber-400/5 to-transparent rounded-xl border border-amber-400/10 backdrop-blur-sm group"
    >
      <motion.div
        className="absolute inset-0 bg-gradient-to-b from-amber-400/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-1000 rounded-xl"
        initial={{ opacity: 0 }}
        whileHover={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      />
      <div className="relative">
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.8, ...springConfig }}
          className="w-12 h-12 mb-4 bg-amber-400/10 rounded-lg flex items-center justify-center group-hover:bg-amber-400/20 transition-colors duration-700"
        >
          <Icon className="w-6 h-6 text-amber-400" />
        </motion.div>
        <motion.h3
          className="text-xl font-semibold text-white mb-2"
          initial={{ opacity: 0.9 }}
          whileHover={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {title}
        </motion.h3>
        <motion.p
          className="text-gray-400"
          initial={{ opacity: 0.7 }}
          whileHover={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {description}
        </motion.p>
      </div>
    </motion.div>
  );
};